<template>
    <div id="PowerInspection">
    <view1/>
    <view2/>
    <view3/>
    <view4/>
    <view5/>
    <view6/>
    </div>

</template>
<script>
    export default {
        name: 'PowerInspection',
        components: {
        view1: () => import('@/views/PowerInspection/view1.vue'),
        view2: () => import('@/views/PowerInspection/view2.vue'),
        view3: () => import('@/views/PowerInspection/view3.vue'),
        view4: () => import('@/views/PowerInspection/view4.vue'),
        view5: () => import('@/views/PowerInspection/view5.vue'),
        view6: () => import('@/views/PowerInspection/view6.vue')
        }
    }
</script>
<style scoped>
</style>